module.exports = __webpack_public_path__ + "static/img/3.c40cb40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruselFuturo/3.jpg
// module id = KnxE
// module chunks = 5